import styled from "styled-components";
import {
    mediaMaxWidthMobile,
    mediaMaxHeight,
    mediaMinHeight,
    mediaTablet,
    mediaUnderMinHeight,
    mediaUnderTablet,
    mediaUnderLaptop
} from "src/styles/mediaQuery";
import {Gmarket_DisPlay2_b24, Gmarket_DisPlay2_b30, Gmarket_DisPlay2_b50} from "src/styles/font/GmarketSansFonts";
import { Noto_heading1_r20, Noto_heading1_r24} from "src/styles/font/NotoSansKrFonts";
import {motion} from "framer-motion";

export const Section = styled(motion.div)`
  position: relative;
  width: 100%;
  height: 100dvh;
  overflow: hidden;
  ${mediaTablet} {
   padding-top:50px;
  }
`;

export const VideoWrapper = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const BackgroundVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

export const Inner = styled.div`
  position: relative;
  width: 100%;
  max-width: 1460px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  ${mediaMaxHeight} {
    transform: scale(.85);
  }

  ${mediaUnderLaptop} {
    transform: scale(.85);
  }

  ${mediaMinHeight} {
    transform: scale(.70);
  }

  ${mediaUnderMinHeight} {
    transform: scale(.55);
  }
  ${mediaTablet} {
    transform: scale(1) !important;
    padding-top: 50px;
    flex-flow: column;
    justify-content: center;
  }
`;



export const TitleLine = styled.h2`
  ${Gmarket_DisPlay2_b50};
  ${mediaTablet} {
    ${Gmarket_DisPlay2_b30};
  }
  ${mediaUnderTablet()} {
    ${Gmarket_DisPlay2_b24};
    line-height: 1.2;
  }
  &.white{
    color:var(--white)
  }
`;

export const LinePoint = styled.span`
  &.main-color {
    color: var(--point-color-1);
  }
`;

export const SubLine = styled.h3`
  ${Noto_heading1_r24};
  color: var(--black-90);
  margin-top: 24px;
  ${mediaTablet} {
    ${Noto_heading1_r20};
    line-height: 1.4;
    margin-top: 6px;
  }
  ${mediaUnderTablet} {
    font-size: 15px;
    line-height: 1.4;
  }

  & .bold {
    font-weight: 700;
  }

  &.white {
    color: var(--white)
  }
`;
export const LineBreak = styled.br`
  &.pc {
    display: block;
    ${mediaTablet} {
      display: none;
    }
  }

  &.mob {
    display: none;
    ${mediaTablet} {
      display: block;
    }
  }
  &.underMob {
    display: none;
    ${mediaMaxWidthMobile} {
      display: block;
    }
  }
`